export var MODULE_BASE_PATH = '/signature';
export default {
  MODULE_BASE_PATH: MODULE_BASE_PATH
};